var render = function () {
  var _vm$bookingPreset$nam, _vm$bookingPreset$nam2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": _vm.isBookingCenter() ? '' : 'BookingSelectList',
      "extra-items": _vm.isBookingCenter() ? ['登記預約中心', (_vm$bookingPreset$nam = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam !== void 0 ? _vm$bookingPreset$nam : ''] : [(_vm$bookingPreset$nam2 = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam2 !== void 0 ? _vm$bookingPreset$nam2 : '']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "\n        d-flex\n        flex-column flex-xl-row\n        align-items-start align-items-xl-center\n        justify-content-between\n        mb-4 mb-xl-2\n      "
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.bookingPreset.name) + " "), _c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "inverse-dark"
    },
    on: {
      "click": function click($event) {
        return _vm.showFormUrl(_vm.bookingPreset);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])], 1), _c('div', {
    staticClass: "d-flex mb-2 mb-md-0"
  }, [_vm.showReportSelect ? _c('b-form-select', {
    staticClass: "report-select flex-shrink-0 mb-0 ml-2 mr-3",
    attrs: {
      "options": _vm.reportSelectOptions
    },
    on: {
      "change": _vm.handleReportChange
    },
    model: {
      value: _vm.selectedReportValue,
      callback: function callback($$v) {
        _vm.selectedReportValue = $$v;
      },
      expression: "selectedReportValue"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "flex-shrink-0 mr-3"
  }, [_c('DateSearchPicker', {
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    model: {
      value: _vm.bookingBetween,
      callback: function callback($$v) {
        _vm.bookingBetween = $$v;
      },
      expression: "bookingBetween"
    }
  })], 1), _c('b-input-group', {}, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋 "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1)]), _c('div', {
    staticClass: "d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', [_vm.checkPermission([_vm.consts.BOOKING_LIST_QUOTATION]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-3",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.multipleCheck
    }
  }, [_c('i', {
    class: _vm.isMultiSelectMode ? 'fa fa-times' : 'fa fa-check-square-o'
  }), _vm._v(_vm._s(_vm.isMultiSelectMode ? '取消多選' : '多選') + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_CREATE]) && _vm.bookingPreset.id ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-3",
    attrs: {
      "variant": "primary",
      "to": _vm.isBookingCenter() ? {
        name: 'BookingCenterBookingCreate',
        params: {
          id: _vm.bookingPreset.id
        },
        query: {
          branch_id: _vm.query.branch_id
        }
      } : {
        name: 'BookingCreate',
        params: {
          id: _vm.bookingPreset.id
        },
        query: {
          branch_id: _vm.query.branch_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增預約 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_PERIODIC_CREATE]) && _vm.bookingPreset.id ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-3",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'PeriodicBookingCreate',
        params: {
          preset_id: _vm.bookingPreset.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增週期性預約 ")]) : _vm._e()], 1), _c('div', [_vm.selectedBookingIds.length > 0 && _vm.checkPermission([_vm.consts.BOOKING_LIST_QUOTATION]) ? _c('b-button', {
    staticClass: "flex-shrink-0 btn ml-3",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.goToPrintSelected
    }
  }, [_c('span', {
    staticClass: "mdi mdi-printer"
  }), _vm._v(" 產出估價單 ")]) : _vm._e(), _c('b-button', {
    staticClass: "flex-shrink-0 btn ml-3",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('span', {
    staticClass: "mdi mdi-download"
  }), _vm._v(" 匯出 ")])], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', {}, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "狀態",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.statusOptions,
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "更新時間",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    model: {
      value: _vm.updatedBetween,
      callback: function callback($$v) {
        _vm.updatedBetween = $$v;
      },
      expression: "updatedBetween"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "會員名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員名稱",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_name", $$v);
      },
      expression: "query.customer_name"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "會員編號",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員編號",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.customer_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_outer_code", $$v);
      },
      expression: "query.customer_outer_code"
    }
  })], 1)], 1), _vm.showServiceSelect || _vm.showBranchSelect || _vm.showStaffSelect ? _c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_vm.showServiceSelect ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "服務",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "service_id", $$v);
      },
      expression: "query.service_id"
    }
  })], 1) : _vm._e(), _vm.showBranchSelect ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "分店",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.showLoading || !this.checkPermission([_vm.consts.BOOKING_LIST_BRANCH])
    },
    on: {
      "input": _vm.formatAndFetch
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1) : _vm._e(), _vm.showStaffSelect ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "員工",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.staffOptions,
      "disabled": _vm.showLoading || !_vm.query.branch_id || _vm.staffOptions.length <= 1
    },
    model: {
      value: _vm.query.staff_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "staff_id", $$v);
      },
      expression: "query.staff_id"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置搜尋條件")]), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.paginatedBookings,
      "fields": _vm.tableFields
    },
    scopedSlots: _vm._u([{
      key: "head(_checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          attrs: {
            "indeterminate": _vm.isIndeterminate,
            "checked": _vm.isAllCurrentPageSelected
          },
          on: {
            "change": _vm.toggleSelectAll
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(_checkbox)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.id
          },
          model: {
            value: _vm.selectedBookingIds,
            callback: function callback($$v) {
              _vm.selectedBookingIds = $$v;
            },
            expression: "selectedBookingIds"
          }
        })];
      }
    }, {
      key: "cell(title)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BOOKING_EDIT]) ? _c('RouterLink', {
          attrs: {
            "to": _vm.linkUsedByBookingTitle(data.item)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " "), data.item.periodicBookingId ? _c('span', {
          staticClass: "mdi mdi-restore ml-2"
        }) : _vm._e()]) : [_vm._v(_vm._s(data.value))]];
      }
    }, {
      key: "cell()",
      fn: function fn(data) {
        return [_vm.isObject(data.value) ? [data.value.type === 'collection_select' && _vm.checkPermission([_vm.consts.COLLECTION_ITEM_MANAGE]) ? _c('RouterLink', {
          attrs: {
            "to": {
              name: 'CollectionItemEdit',
              params: {
                id: data.value.collection_id,
                item_id: data.value.collection_item_id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.value.text) + " ")]) : [_vm._v(_vm._s(data.value.text))]] : data.field.type === 'uploader' ? [data.value ? _c('a', {
          attrs: {
            "href": data.value,
            "target": "_blank"
          }
        }, [_vm._v("（查看檔案）")]) : [_vm._v("（無檔案）")]] : data.field.is_dynamic_generated ? [_vm._v(_vm._s(_vm.truncateText(data.value, 15)))] : [_vm._v(_vm._s(data.value))]];
      }
    }, {
      key: "cell(date)",
      fn: function fn(data) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.displayDate(data.item))
          }
        })];
      }
    }, {
      key: "cell(branch_id)",
      fn: function fn(data) {
        var _data$item$branch$nam, _data$item$branch;
        return [_c('span', [_vm._v(_vm._s((_data$item$branch$nam = (_data$item$branch = data.item.branch) === null || _data$item$branch === void 0 ? void 0 : _data$item$branch.name) !== null && _data$item$branch$nam !== void 0 ? _data$item$branch$nam : ''))])];
      }
    }, {
      key: "cell(staff_id)",
      fn: function fn(data) {
        var _data$item$staff$name, _data$item$staff;
        return [_c('span', [_vm._v(_vm._s((_data$item$staff$name = (_data$item$staff = data.item.staff) === null || _data$item$staff === void 0 ? void 0 : _data$item$staff.name) !== null && _data$item$staff$name !== void 0 ? _data$item$staff$name : ''))])];
      }
    }, {
      key: "cell(customer)",
      fn: function fn(data) {
        var _data$item$customer, _data$item$customer2;
        return [(_data$item$customer = data.item.customer) !== null && _data$item$customer !== void 0 && _data$item$customer.avatar_url ? _c('b-avatar', {
          staticClass: "mx-1",
          attrs: {
            "size": "2em",
            "src": data.item.customer.avatar_url
          }
        }) : _vm._e(), (_data$item$customer2 = data.item.customer) !== null && _data$item$customer2 !== void 0 && _data$item$customer2.name ? _c('span', [_vm._v(_vm._s(data.item.customer.name))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("無會員")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BOOKING_LIST_QUOTATION]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'BookingCenterBookingPrint',
              params: {
                id: _vm.bookingPreset.id
              },
              query: {
                booking_ids: [data.item.id]
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-printer"
        }), _vm._v(" 估價單 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_EDIT]) && _vm.updateStatusOptions.length > 0 ? _c('b-dropdown', {
          staticClass: "mr-1",
          attrs: {
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _vm.checkPermission([_vm.consts.BOOKING_EDIT]) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.openStatusModal(data.item);
            }
          }
        }, [_vm._v(" 變更狀態與推播 ")]) : _vm._e()], 2) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_LIST]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": _vm.linkUsedByBookingViewButton(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_EDIT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": _vm.linkUsedByBookingEditButton(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBooking(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "form-status-modal",
      "footer-class": "d-flex justify-content-center",
      "hide-header": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "size": "lg",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              _vm.$bvModal.hide('form-status-modal');
              _vm.changedStatus = false;
            }
          }
        }, [_vm._v("關閉")]), _c('b-button', {
          attrs: {
            "size": "lg",
            "variant": "success"
          },
          on: {
            "click": _vm.changeBookingStatus
          }
        }, [_vm._v(_vm._s(_vm.changeBookingStatusWording))])];
      },
      proxy: true
    }])
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("變更狀態與推播")]), _c('h4', [_vm._v("狀態")]), _c('b-select', {
    staticClass: "mr-3",
    attrs: {
      "id": "form-status",
      "options": _vm.updateStatusOptions
    },
    on: {
      "change": function change($event) {
        _vm.changedStatus = true;
      }
    },
    model: {
      value: _vm.selectedItemStatus,
      callback: function callback($$v) {
        _vm.selectedItemStatus = $$v;
      },
      expression: "selectedItemStatus"
    }
  })], 1), _c('FormUrlModal', {
    ref: "formUrlModal"
  }), _c('ScopeDeleteModal', {
    ref: "scopeDeleteModal",
    on: {
      "confirm": _vm.handleScopeDeleteConfirm
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }